import React, { useState } from 'react';
import { Search, Plus, FileText, ChevronLeft, ChevronRight } from 'lucide-react';
import { Select, Drawer } from 'antd';

export default function AppointmentManagement() {
  const [activeTab, setActiveTab] = useState<'Ngày' | 'Tuần' | 'Tháng' | 'Quý' | 'Timeline' | 'Danh sách'>('Tháng');
  const [activeCategory, setActiveCategory] = useState<string>('Tất cả');
  const [searchQuery, setSearchQuery] = useState<string>('');

  // State điều khiển mở Drawer "Tạo hẹn tương lai"
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  // State quản lý thông tin khách hàng đang chọn để xem chi tiết
  const [selectedCustomer, setSelectedCustomer] = useState<{
    name: string;
    service?: string;
    status?: string;
    appointmentTime?: string;
    telesale?: string;
    phone?: string;
    estimatedValue?: string;
    nextTouch?: string;
  } | null>(null);

  // State Form Tạo Hẹn
  const [formData, setFormData] = useState({
    customerName: '',
    phone: '',
    interestedService: '',
    serviceGroup: 'Clinic',
    appointmentType: 'Khách mới hẹn tư vấn',
    telesale: 'Ninh Giang',
    day: '20',
    time: '10:00',
  });

  const handleCreateAppointment = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Dữ liệu hẹn mới:', formData);
    setIsDrawerOpen(false);
  };

  // Dữ liệu KPI Cards
  const kpiCards = [
    {
      id: '1',
      number: 12,
      label: 'HẸN TƯƠNG LAI',
      sublabel: 'Telesale · 29/08/2026',
      borderLeft: 'border-l-cyan-600',
      numColor: 'text-cyan-800 dark:text-cyan-400',
    },
    {
      id: '2',
      number: 4,
      label: 'Cần chạm lại tuần này',
      borderLeft: 'border-l-rose-500',
      numColor: 'text-rose-600 dark:text-rose-400',
    },
    {
      id: '3',
      number: 2,
      label: 'Tới ngưỡng T-3',
      borderLeft: 'border-l-amber-500',
      numColor: 'text-amber-600 dark:text-amber-400',
    },
    {
      id: '4',
      number: 5,
      label: 'Chưa chốt ngày',
      borderLeft: 'border-l-slate-400',
      numColor: 'text-slate-700 dark:text-slate-300',
    },
    {
      id: '5',
      number: 1,
      label: 'Quá hạn chạm lại',
      borderLeft: 'border-l-indigo-600',
      numColor: 'text-indigo-800 dark:text-indigo-400',
    },
  ];

  // Dữ liệu danh sách hẹn đầy đủ dùng cho tab "Danh sách" và "Timeline"
  const listAppointments = [
    {
      id: 'l1',
      avatar: 'QL',
      customer: 'Quinn Le',
      staff: 'Trương Mỹ Hiệp',
      time: '10/9 · 13:00',
      timelinePercent: 28,
      service: 'Ultherapy Prime + Rejuran + Thermage FLX (mắt, mặt)',
      certainty: 'Đã chốt ngày giờ',
      certaintyType: 'green',
      appointmentType: 'Khách mới hẹn tư vấn',
      estimatedValue: '45.000.000',
      nextTouch: '02/9',
      isOverdue: false,
      actionText: 'Chi tiết',
      phone: '0901 234 567',
    },
    {
      id: 'l2',
      avatar: 'TV',
      customer: 'Phạm Thị Thuý Vi',
      staff: 'Hồ Nhi (CSKH)',
      time: '12/9 · 17:00',
      timelinePercent: 38,
      service: 'Căng da mặt toàn phần nội soi',
      certainty: 'Đã chốt ngày giờ',
      certaintyType: 'green',
      appointmentType: 'Khách mới hẹn tư vấn',
      estimatedValue: '85.500.000',
      nextTouch: '05/9',
      isOverdue: false,
      actionText: 'Chi tiết',
      phone: '0902 345 678',
    },
    {
      id: 'l3',
      avatar: 'KK',
      customer: 'Katie Katie',
      staff: 'Hồ Nhi (CSKH)',
      time: '15/9 · 10:00',
      timelinePercent: 48,
      service: 'Nâng cơ trẻ hóa đa tầng Ultherapy',
      certainty: 'Đã chốt ngày giờ',
      certaintyType: 'green',
      appointmentType: 'Khách mới hẹn tư vấn',
      estimatedValue: 'ước 40.000.000',
      nextTouch: '12/9',
      isOverdue: false,
      actionText: 'Chi tiết',
      phone: '0903 456 789',
    },
    {
      id: 'l4',
      avatar: 'TP',
      customer: 'Tran Pham',
      staff: 'Ninh Giang',
      time: 'chờ khách báo',
      timelinePercent: 0,
      service: 'Karisma RH collagen · chương trình Festival',
      certainty: 'Chờ khách báo lại',
      certaintyType: 'slate',
      appointmentType: 'Khách mới hẹn tư vấn',
      estimatedValue: '7.990.000',
      nextTouch: 'quá hạn',
      isOverdue: true,
      actionText: 'Gọi chốt ngày',
      phone: '0904 567 890',
    },
    {
      id: 'l5',
      avatar: 'JV',
      customer: 'Jonathan Vo',
      staff: 'Quang',
      time: '02/10 · 10:00',
      timelinePercent: 82,
      service: 'Cấy tóc tự thân · 2.500 – 3.000 nang',
      certainty: 'Đã chốt ngày giờ',
      certaintyType: 'green',
      appointmentType: 'Khách mới hẹn tư vấn',
      estimatedValue: '85.000.000',
      nextTouch: '15/9',
      isOverdue: false,
      actionText: 'Chi tiết',
      phone: '0905 678 901',
    },
  ];

  // Dữ liệu hẹn CHƯA CHỐT NGÀY CỤ THỂ (Giao diện Tháng)
  const unconfirmedAppointments = [
    {
      id: 'u1',
      customer: 'Katie Katie',
      timeLabel: 'đầu tháng 9',
      service: 'Nâng cơ trẻ hóa đa tầng Ultherapy',
      badges: [
        { text: 'Chỉ chốt tháng', type: 'amber' },
        { text: 'Khách mới hẹn tư vấn', type: 'gray' },
      ],
      estimatedValue: 'ước 40.000.000 đ',
      lastTouch: '27/8 15:35',
      nextTouch: '01/9',
      nextTouchOverdue: false,
      phoneBtn: true,
    },
    {
      id: 'u2',
      customer: 'Tran Pham',
      timeLabel: 'chờ khách báo',
      service: 'Karisma RH collagen · chương trình Festival',
      badges: [
        { text: 'Chờ khách báo lại', type: 'slate' },
        { text: 'Khách mới hẹn tư vấn', type: 'gray' },
      ],
      estimatedValue: '7.990.000 đ',
      lastTouch: '27/8 11:00',
      nextTouch: 'quá hạn',
      nextTouchOverdue: true,
      phoneBtn: false,
    },
    {
      id: 'u3',
      customer: 'Mỹ Dáng',
      timeLabel: 'chờ khách báo',
      service: 'Cấy mỡ hai bên má',
      badges: [
        { text: 'Chờ khách báo lại', type: 'slate' },
        { text: 'Cần hẹn lại', type: 'gray' },
      ],
      lastTouch: '28/8 14:00',
      nextTouch: '30/8',
      nextTouchOverdue: false,
      phoneBtn: true,
    },
    {
      id: 'u4',
      customer: 'Thanh Yen',
      timeLabel: 'chờ khách báo',
      service: 'Thăm khám tư vấn',
      badges: [
        { text: 'Chờ khách báo lại', type: 'slate' },
        { text: 'Cần hẹn lại', type: 'gray' },
      ],
      lastTouch: '25/8 14:00',
      nextTouch: '31/8',
      nextTouchOverdue: false,
      phoneBtn: true,
    },
    {
      id: 'u5',
      customer: 'Tina Nguyen',
      timeLabel: '—',
      service: 'Cấy tóc tự thân · Newhair 1.200 nang',
      badges: [
        { text: 'Chờ khách báo lại', type: 'slate' },
        { text: 'Xếp ca sau tư vấn', type: 'gray' },
      ],
      estimatedValue: '38.000.000 đ',
      lastTouch: '28/8',
      nextTouch: '3/9',
      nextTouchOverdue: false,
      phoneBtn: false,
    },
  ];

  // Dữ liệu Lưới thời gian Tháng 9/2026
  const monthGridDays: Array<{
    dayNumber: number | null;
    events: Array<{ time: string; customer: string }>;
  }> = [
    { dayNumber: null, events: [] },
    { dayNumber: 1, events: [] },
    { dayNumber: 2, events: [] },
    { dayNumber: 3, events: [] },
    { dayNumber: 4, events: [] },
    { dayNumber: 5, events: [{ time: '09:30', customer: 'Lê Nhân' }] },
    { dayNumber: 6, events: [] },
    { dayNumber: 7, events: [] },
    { dayNumber: 8, events: [] },
    { dayNumber: 9, events: [{ time: '11:30', customer: 'Ngọc Ánh' }] },
    { dayNumber: 10, events: [{ time: '13:00', customer: 'Quinn Le' }] },
    { dayNumber: 11, events: [] },
    { dayNumber: 12, events: [{ time: '17:00', customer: 'Phạm Thị Thuý Vi' }] },
    { dayNumber: 13, events: [] },
    { dayNumber: 14, events: [] },
    { dayNumber: 15, events: [] },
    { dayNumber: 16, events: [] },
    { dayNumber: 17, events: [] },
    { dayNumber: 18, events: [{ time: '15:00', customer: 'Kim Tuyết' }] },
    { dayNumber: 19, events: [] },
    { dayNumber: 20, events: [] },
    { dayNumber: 21, events: [] },
    { dayNumber: 22, events: [{ time: '14:00', customer: 'Lưu Thị Tường Vi' }] },
    { dayNumber: 23, events: [] },
    { dayNumber: 24, events: [] },
    { dayNumber: 25, events: [] },
    { dayNumber: 26, events: [] },
    { dayNumber: 27, events: [] },
    { dayNumber: 28, events: [] },
    { dayNumber: 29, events: [] },
    { dayNumber: 30, events: [] },
    { dayNumber: null, events: [] },
    { dayNumber: null, events: [] },
    { dayNumber: null, events: [] },
    { dayNumber: null, events: [] },
  ];

  // Dữ liệu Chế độ QUÝ
  const quarterMonthsData = [
    {
      monthNumber: 9,
      title: 'Tháng 9/2026',
      totalAppointments: 7,
      days: [
        null, null, 1, 2, 3, 4, 5,
        7, 8, 9, 10, 11, 12, 13,
        14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27,
        28, 29, 30
      ],
      highlightedDays: [5, 9, 10, 12, 15, 18, 22],
    },
    {
      monthNumber: 10,
      title: 'Tháng 10/2026',
      totalAppointments: 1,
      days: [
        null, null, null, 1, 2, 3, 4,
        5, 6, 7, 8, 9, 10, 11,
        12, 13, 14, 15, 16, 17, 18,
        19, 20, 21, 22, 23, 24, 25,
        26, 27, 28, 29, 30, 31
      ],
      highlightedDays: [2],
    },
    {
      monthNumber: 11,
      title: 'Tháng 11/2026',
      totalAppointments: 0,
      days: [
        null, null, null, null, null, null, 1,
        2, 3, 4, 5, 6, 7, 8,
        9, 10, 11, 12, 13, 14, 15,
        16, 17, 18, 19, 20, 21, 22,
        23, 24, 25, 26, 27, 28, 29,
        30
      ],
      highlightedDays: [],
    },
  ];

  // Dữ liệu khung giờ chế độ NGÀY
  const timeSlots = [
    {
      time: '08:00',
      count: 1,
      tasks: [
        {
          id: 't1',
          customer: 'Tran Pham',
          service: 'Karisma RH collagen · chương trình Festival',
          status: 'Chờ khách báo lại',
        },
      ],
    },
    {
      time: '09:00',
      count: 1,
      tasks: [
        {
          id: 't2',
          customer: 'Mỹ Dáng',
          service: 'Cấy mỡ hai bên má',
          status: 'Chờ khách báo lại',
        },
      ],
    },
    {
      time: '10:00',
      count: 1,
      tasks: [
        {
          id: 't3',
          customer: 'Thanh Yen',
          service: 'Thăm khám tư vấn',
          status: 'Chờ khách báo lại',
        },
      ],
    },
    { time: '11:00', count: 0, tasks: [] },
    { time: '12:00', count: 0, tasks: [] },
    { time: '13:00', count: 0, tasks: [] },
    { time: '14:00', count: 0, tasks: [] },
    { time: '15:00', count: 0, tasks: [] },
    { time: '16:00', count: 0, tasks: [] },
    { time: '17:00', count: 0, tasks: [] },
  ];

  // Dữ liệu chế độ TUẦN
  const weekDays = [
    {
      dayLabel: 'T2 - 24',
      tasks: [{ id: 'w1', status: 'đã chạm', customer: 'Jonathan Vo', service: 'Cấy tóc tự thân · 2.500 – 3.000 nang', type: 'gray' }],
    },
    {
      dayLabel: 'T3 - 25',
      tasks: [
        { id: 'w2', status: 'đã chạm', customer: 'Lê Nhân', type: 'gray' },
        { id: 'w3', status: 'đã chạm', customer: 'Ngọc Ánh', type: 'gray' },
      ],
    },
    {
      dayLabel: 'T4 - 26',
      tasks: [{ id: 'w4', status: 'đã chạm', customer: 'Phạm Thị Thuý Vi', type: 'gray' }],
    },
    {
      dayLabel: 'T5 - 27',
      tasks: [{ id: 'w5', status: 'đã chạm', customer: 'Quinn Le', type: 'gray' }],
    },
    {
      dayLabel: 'T6 - 28',
      isToday: true,
      tasks: [{ id: 'w6', status: 'đã chạm', customer: 'Kim Tuyết', type: 'gray' }],
    },
    {
      dayLabel: 'T7 - 29',
      tasks: [
        { id: 'w7', status: 'đã chạm', customer: 'Lưu Thị Tường Vi', type: 'gray' },
        { id: 'w8', status: 'đã chạm', customer: '123123', type: 'gray' },
      ],
    },
    {
      dayLabel: 'CN - 30',
      tasks: [],
    },
  ];

  // Các tabs danh mục con
  const categories = [
    { name: 'Tất cả', count: 12 },
    { name: 'Khách mới hẹn tư vấn', count: 5 },
    { name: 'Khách cũ hẹn tư vấn lại', count: 3 },
    { name: 'Tái khám sau dịch vụ', count: 1 },
    { name: 'Cần hẹn lại', count: 3 },
  ];

  // Options bộ lọc
  const TELESALE_OPTIONS = [
    { value: 'Tất cả', label: 'Tất cả' },
    { value: 'Ninh Giang', label: 'Ninh Giang' },
    { value: 'Quang', label: 'Quang' },
    { value: 'Trương Mỹ Hiệp', label: 'Trương Mỹ Hiệp' },
    { value: 'Bửu Châu', label: 'Bửu Châu' },
    { value: 'Hồ Nhi (CSKH)', label: 'Hồ Nhi (CSKH)' },
  ];

  const SERVICE_OPTIONS = [
    { value: 'Tất cả', label: 'Tất cả' },
    { value: 'Newhair', label: 'Newhair' },
    { value: 'Clinic', label: 'Clinic' },
    { value: 'PTTM', label: 'PTTM' },
    { value: 'Thăm khám', label: 'Thăm khám' },
  ];

  const STATUS_OPTIONS = [
    { value: 'Tất cả', label: 'Tất cả' },
    { value: 'Đã chốt ngày giờ', label: 'Đã chốt ngày giờ' },
    { value: 'Chỉ chốt tháng', label: 'Chỉ chốt tháng' },
    { value: 'Chờ khách báo lại', label: 'Chờ khách báo lại' },
  ];

  const customSelectPopupClass =
    'dark:[&_.ant-select-dropdown]:!bg-slate-800 dark:[&_.ant-select-item]:!text-slate-200 dark:[&_.ant-select-item-option-selected]:!bg-slate-700 dark:[&_.ant-select-item-option-selected]:!text-blue-400 dark:[&_.ant-select-item-option-active]:!bg-slate-700/60';

  return (
    <div className="p-4 sm:p-6 bg-slate-100 dark:bg-slate-900 min-h-screen text-slate-800 dark:text-slate-100 space-y-4 transition-colors duration-200">
      {/* 1. Header tiêu đề */}
      <div>
        <h1 className="text-lg sm:text-xl font-bold text-slate-900 dark:text-white">Lịch hẹn</h1>
        <p className="text-xs text-slate-500 dark:text-slate-400 mt-1 max-w-5xl leading-relaxed">
          Hẹn tương lai do telesale tạo, và việc chạm lại để chốt được ngày giờ. Hẹn chưa chốt ngày không xếp được
          vào lưới — nằm riêng ở khối trên. Số liệu pipeline không nằm ở màn này, xem trong báo cáo.
        </p>
      </div>

      {/* 2. Thống kê KPI Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
        {kpiCards.map((card) => (
          <div
            key={card.id}
            className={`bg-white dark:bg-slate-800 p-3.5 rounded-lg border border-slate-200 dark:border-slate-700 shadow-2xs border-l-4 ${card.borderLeft} flex items-center justify-between transition-colors`}
          >
            <div className="flex items-baseline gap-3">
              <span className={`text-2xl font-black ${card.numColor}`}>{card.number}</span>
              <div>
                <div className="text-xs font-bold text-slate-700 dark:text-slate-200 uppercase tracking-tight">
                  {card.label}
                </div>
                {card.sublabel && (
                  <div className="text-[10px] text-slate-400 dark:text-slate-500 mt-0.5">{card.sublabel}</div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* 3. Thanh bộ lọc & Thao tác */}
      <div className="flex flex-col xl:flex-row items-stretch xl:items-center justify-between gap-3 pt-1">
        <div className="flex items-center flex-wrap gap-2">
          <div className="relative w-full sm:w-auto">
            <Search className="w-3.5 h-3.5 text-slate-400 dark:text-slate-500 absolute left-2.5 top-2.5" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Tên khách, số điện thoại, mã hẹn"
              className="pl-8 pr-3 py-1.5 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-md text-xs focus:outline-none focus:border-blue-500 dark:focus:border-blue-400 w-full sm:w-60 shadow-2xs placeholder:text-slate-400 dark:placeholder:text-slate-500 text-slate-800 dark:text-slate-200 transition-colors"
            />
          </div>

          <div className="inline-flex items-center border border-slate-200 dark:border-slate-700 rounded-md bg-white dark:bg-slate-800 px-2.5 py-1 text-xs shadow-2xs hover:border-slate-300 dark:hover:border-slate-600 transition-colors">
            <span className="text-slate-400 dark:text-slate-500 mr-1 whitespace-nowrap">Telesale:</span>
            <Select
              defaultValue="Tất cả"
              variant="borderless"
              size="small"
              options={TELESALE_OPTIONS}
              popupMatchSelectWidth={false}
              dropdownStyle={{ minWidth: 180 }}
              placement="bottomRight"
              popupClassName={customSelectPopupClass}
              className="font-semibold text-xs text-slate-800 dark:text-slate-200 p-0 [&_.ant-select-selection-item]:font-semibold [&_.ant-select-selection-item]:text-slate-800 dark:[&_.ant-select-selection-item]:text-slate-200 dark:[&_.ant-select-arrow]:text-slate-400"
            />
          </div>

          <div className="inline-flex items-center border border-slate-200 dark:border-slate-700 rounded-md bg-white dark:bg-slate-800 px-2.5 py-1 text-xs shadow-2xs hover:border-slate-300 dark:hover:border-slate-600 transition-colors">
            <span className="text-slate-400 dark:text-slate-500 mr-1 whitespace-nowrap">Dịch vụ:</span>
            <Select
              defaultValue="Tất cả"
              variant="borderless"
              size="small"
              options={SERVICE_OPTIONS}
              popupMatchSelectWidth={false}
              dropdownStyle={{ minWidth: 170 }}
              placement="bottomRight"
              popupClassName={customSelectPopupClass}
              className="font-semibold text-xs text-slate-800 dark:text-slate-200 p-0 [&_.ant-select-selection-item]:font-semibold [&_.ant-select-selection-item]:text-slate-800 dark:[&_.ant-select-selection-item]:text-slate-200 dark:[&_.ant-select-arrow]:text-slate-400"
            />
          </div>

          <div className="inline-flex items-center border border-slate-200 dark:border-slate-700 rounded-md bg-white dark:bg-slate-800 px-2.5 py-1 text-xs shadow-2xs hover:border-slate-300 dark:hover:border-slate-600 transition-colors">
            <span className="text-slate-400 dark:text-slate-500 mr-1 whitespace-nowrap">Mức chắc chắn:</span>
            <Select
              defaultValue="Tất cả"
              variant="borderless"
              size="small"
              options={STATUS_OPTIONS}
              popupMatchSelectWidth={false}
              dropdownStyle={{ minWidth: 190 }}
              placement="bottomRight"
              popupClassName={customSelectPopupClass}
              className="font-semibold text-xs text-slate-800 dark:text-slate-200 p-0 [&_.ant-select-selection-item]:font-semibold [&_.ant-select-selection-item]:text-slate-800 dark:[&_.ant-select-selection-item]:text-slate-200 dark:[&_.ant-select-arrow]:text-slate-400"
            />
          </div>
        </div>

        <div className="flex items-center gap-2 self-start xl:self-auto">
          <button className="flex-1 sm:flex-initial flex items-center justify-center gap-1.5 px-3 py-1.5 bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 font-medium rounded-md border border-slate-200 dark:border-slate-700 text-xs transition-colors shadow-2xs">
            <FileText className="w-3.5 h-3.5 text-slate-500 dark:text-slate-400" />
            Xuất Excel
          </button>

          <button
            onClick={() => setIsDrawerOpen(true)}
            className="flex-1 sm:flex-initial flex items-center justify-center gap-1.5 px-3.5 py-1.5 bg-teal-800 hover:bg-teal-900 dark:bg-teal-700 dark:hover:bg-teal-600 text-white font-semibold rounded-md text-xs transition-colors shadow-2xs"
          >
            <Plus className="w-3.5 h-3.5" />
            Tạo hẹn tương lai
          </button>
        </div>
      </div>

      {/* 4. Tab Chế độ xem */}
      <div className="flex items-center gap-4 sm:gap-6 pt-2 text-xs overflow-x-auto pb-1 scrollbar-none">
        <div className="flex items-center gap-2 shrink-0">
          <span className="font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-[11px]">
            VIỆC CHẠM LẠI
          </span>
          <div className="bg-slate-200/70 dark:bg-slate-800 p-0.5 rounded-md flex gap-0.5">
            <button
              onClick={() => setActiveTab('Ngày')}
              className={`px-3 py-1 rounded text-xs transition-all ${
                activeTab === 'Ngày'
                  ? 'bg-white dark:bg-slate-700 font-bold text-slate-800 dark:text-white shadow-2xs'
                  : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200'
              }`}
            >
              Ngày
            </button>
            <button
              onClick={() => setActiveTab('Tuần')}
              className={`px-3 py-1 rounded text-xs transition-all ${
                activeTab === 'Tuần'
                  ? 'bg-white dark:bg-slate-700 font-bold text-slate-800 dark:text-white shadow-2xs'
                  : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200'
              }`}
            >
              Tuần
            </button>
          </div>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <span className="font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider text-[11px]">
            HẸN TƯƠNG LAI
          </span>
          <div className="bg-slate-200/70 dark:bg-slate-800 p-0.5 rounded-md flex gap-0.5">
            {(['Tháng', 'Quý', 'Timeline', 'Danh sách'] as const).map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-3 py-1 rounded text-xs transition-all ${
                  activeTab === tab
                    ? 'bg-white dark:bg-slate-700 font-bold text-slate-800 dark:text-white shadow-2xs'
                    : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* 5. Sub-tabs Phân loại danh mục */}
      <div className="flex items-center gap-4 sm:gap-6 border-b border-slate-200 dark:border-slate-700 pb-2.5 text-xs pt-1 overflow-x-auto scrollbar-none">
        {categories.map((cat) => (
          <button
            key={cat.name}
            onClick={() => setActiveCategory(cat.name)}
            className={`flex items-center gap-1.5 whitespace-nowrap transition-colors pb-1 ${
              activeCategory === cat.name
                ? 'font-bold text-slate-900 dark:text-white border-b-2 border-slate-900 dark:border-white'
                : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'
            }`}
          >
            <span>{cat.name}</span>
            <span className="text-[11px] font-semibold text-slate-400 dark:text-slate-500">{cat.count}</span>
          </button>
        ))}
      </div>

      {/* 6. Nội dung chính hiển thị theo activeTab */}
      {activeTab === 'Timeline' ? (
        /* GIAO DIỆN TIMELINE (HÌNH 1) */
        <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-5 shadow-2xs space-y-6 transition-colors">
          <div>
            <h2 className="text-sm sm:text-base font-bold text-slate-900 dark:text-white">Timeline hẹn tương lai</h2>
            <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
              Mỗi dòng là một khách, chiều dài là khoảng chờ từ hôm nay tới ngày hẹn
            </p>
          </div>

          <div className="space-y-5 pt-2">
            {listAppointments
              .filter((item) => item.timelinePercent > 0)
              .map((item) => (
                <div
                  key={item.id}
                  onClick={() =>
                    setSelectedCustomer({
                      name: item.customer,
                      service: item.service,
                      status: item.certainty,
                      appointmentTime: item.time,
                      telesale: item.staff,
                      phone: item.phone,
                      estimatedValue: item.estimatedValue,
                      nextTouch: item.nextTouch,
                    })
                  }
                  className="flex items-center group cursor-pointer"
                >
                  {/* Tên khách hàng bên trái */}
                  <div className="w-36 sm:w-48 text-right font-semibold text-xs text-slate-700 dark:text-slate-200 pr-4 shrink-0 group-hover:text-teal-700 dark:group-hover:text-teal-400 transition-colors">
                    {item.customer}
                  </div>

                  {/* Thanh timeline với điểm kết thúc dạng chấm màu xanh */}
                  <div className="flex-1 relative flex items-center py-1">
                    <div className="relative flex items-center" style={{ width: `${item.timelinePercent}%` }}>
                      <div className="w-full bg-slate-300 dark:bg-slate-600 h-[2.5px] rounded-l-full"></div>
                      <div className="w-2.5 h-2.5 rounded-full bg-emerald-600 shrink-0 shadow-2xs"></div>
                    </div>
                  </div>

                  {/* Thời gian hẹn bên phải */}
                  <div className="w-28 sm:w-36 text-right font-mono text-xs text-slate-700 dark:text-slate-300 pl-4 shrink-0 whitespace-pre-line leading-snug">
                    {item.time}
                  </div>
                </div>
              ))}
          </div>
        </div>
      ) : activeTab === 'Danh sách' ? (
        /* GIAO DIỆN DANH SÁCH (HÌNH 2) */
        <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 overflow-hidden shadow-2xs transition-colors">
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse min-w-[980px]">
              <thead>
                <tr className="bg-slate-50/70 dark:bg-slate-800/80 border-b border-slate-200 dark:border-slate-700 text-[11px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  <th className="py-3 px-4">KHÁCH HÀNG</th>
                  <th className="py-3 px-3">THỜI ĐIỂM</th>
                  <th className="py-3 px-3">DỊCH VỤ</th>
                  <th className="py-3 px-3">MỨC CHẮC CHẮN</th>
                  <th className="py-3 px-3">LOẠI HẸN</th>
                  <th className="py-3 px-3">GIÁ TRỊ</th>
                  <th className="py-3 px-3">CHẠM KẾ</th>
                  <th className="py-3 px-4 text-right"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-700/60 text-xs">
                {listAppointments.map((item) => (
                  <tr
                    key={item.id}
                    onClick={() =>
                      setSelectedCustomer({
                        name: item.customer,
                        service: item.service,
                        status: item.certainty,
                        appointmentTime: item.time,
                        telesale: item.staff,
                        phone: item.phone,
                        estimatedValue: item.estimatedValue,
                        nextTouch: item.nextTouch,
                      })
                    }
                    className="hover:bg-slate-50/80 dark:hover:bg-slate-700/40 cursor-pointer transition-colors"
                  >
                    {/* KHÁCH HÀNG */}
                    <td className="py-3 px-4">
                      <div className="flex items-center gap-2.5">
                        <div className="w-8 h-8 rounded-full bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 font-bold flex items-center justify-center text-xs shrink-0 border border-slate-200/60 dark:border-slate-600">
                          {item.avatar}
                        </div>
                        <div>
                          <div className="font-bold text-slate-900 dark:text-white">{item.customer}</div>
                          <div className="text-[11px] text-slate-400 dark:text-slate-500">{item.staff}</div>
                        </div>
                      </div>
                    </td>

                    {/* THỜI ĐIỂM */}
                    <td className="py-3 px-3 font-mono text-slate-700 dark:text-slate-300 whitespace-nowrap">
                      {item.time}
                    </td>

                    {/* DỊCH VỤ */}
                    <td className="py-3 px-3 text-slate-800 dark:text-slate-200 max-w-[260px] truncate">
                      {item.service}
                    </td>

                    {/* MỨC CHẮC CHẮN */}
                    <td className="py-3 px-3 whitespace-nowrap">
                      <span
                        className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-medium border ${
                          item.certaintyType === 'green'
                            ? 'bg-emerald-50 dark:bg-emerald-950/40 text-emerald-700 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800'
                            : 'bg-slate-100 dark:bg-slate-700/60 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-600'
                        }`}
                      >
                        <span
                          className={`w-1.5 h-1.5 rounded-full ${
                            item.certaintyType === 'green' ? 'bg-emerald-500' : 'bg-slate-400'
                          }`}
                        ></span>
                        {item.certainty}
                      </span>
                    </td>

                    {/* LOẠI HẸN */}
                    <td className="py-3 px-3 text-slate-600 dark:text-slate-300 whitespace-nowrap">
                      {item.appointmentType}
                    </td>

                    {/* GIÁ TRỊ */}
                    <td className="py-3 px-3 font-medium text-slate-800 dark:text-slate-200 whitespace-nowrap">
                      {item.estimatedValue}
                    </td>

                    {/* CHẠM KẾ */}
                    <td className="py-3 px-3 font-mono whitespace-nowrap">
                      <span
                        className={
                          item.isOverdue
                            ? 'text-rose-600 dark:text-rose-400 font-bold'
                            : 'text-slate-700 dark:text-slate-300'
                        }
                      >
                        {item.nextTouch}
                      </span>
                    </td>

                    {/* THAO TÁC */}
                    <td className="py-3 px-4 text-right whitespace-nowrap">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedCustomer({
                            name: item.customer,
                            service: item.service,
                            status: item.certainty,
                            appointmentTime: item.time,
                            telesale: item.staff,
                            phone: item.phone,
                            estimatedValue: item.estimatedValue,
                            nextTouch: item.nextTouch,
                          });
                        }}
                        className={`px-3 py-1 rounded border text-xs font-medium transition-colors shadow-2xs ${
                          item.isOverdue
                            ? 'bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 border-slate-200 dark:border-slate-700'
                            : 'bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-200 border-slate-200 dark:border-slate-700'
                        }`}
                      >
                        {item.actionText}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : activeTab === 'Quý' ? (
        /* GIAO DIỆN QUÝ (Hiển thị 3 tháng liên tiếp) */
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-1">
          {quarterMonthsData.map((monthData, mIdx) => (
            <div
              key={mIdx}
              className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-4 shadow-2xs space-y-3 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="font-bold text-sm text-slate-900 dark:text-white">
                  {monthData.title}
                </span>
                <span className="text-xs text-slate-400 dark:text-slate-500 font-medium">
                  {monthData.totalAppointments} hẹn
                </span>
              </div>

              <div className="grid grid-cols-7 text-center text-[11px] font-semibold text-slate-400 dark:text-slate-500 py-1">
                <div>T2</div>
                <div>T3</div>
                <div>T4</div>
                <div>T5</div>
                <div>T6</div>
                <div>T7</div>
                <div>CN</div>
              </div>

              <div className="grid grid-cols-7 text-center text-xs gap-y-2 py-1">
                {monthData.days.map((day, dIdx) => {
                  if (day === null) {
                    return <div key={dIdx} className="h-8" />;
                  }

                  const isHighlighted = monthData.highlightedDays.includes(day);

                  return (
                    <div key={dIdx} className="flex items-center justify-center h-8">
                      {isHighlighted ? (
                        <div
                          onClick={() =>
                            setSelectedCustomer({
                              name: 'Khách hàng hẹn quý',
                              service: 'Thăm khám tư vấn',
                              status: 'Đã chốt ngày',
                              appointmentTime: `${day}/${monthData.monthNumber} · 10:00`,
                              telesale: 'Ninh Giang',
                            })
                          }
                          className="w-8 h-8 rounded-lg bg-emerald-100/80 dark:bg-emerald-950/60 text-emerald-900 dark:text-emerald-300 font-bold flex flex-col items-center justify-center cursor-pointer hover:bg-emerald-200 dark:hover:bg-emerald-900/80 transition-colors relative"
                        >
                          <span className="text-xs leading-none">{day}</span>
                          <span className="w-1 h-1 rounded-full bg-emerald-600 dark:bg-emerald-400 mt-0.5"></span>
                        </div>
                      ) : (
                        <span className="text-slate-600 dark:text-slate-400 text-xs">
                          {day}
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      ) : activeTab === 'Tháng' ? (
        /* GIAO DIỆN THÁNG */
        <div className="space-y-4">
          <div className="flex items-center justify-between pt-1">
            <div>
              <h2 className="text-base font-bold text-slate-900 dark:text-white">Tháng 9/2026</h2>
              <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                6 hẹn đã chốt ngày · 5 hẹn chưa chốt ngày
              </p>
            </div>
            <div className="flex items-center gap-1">
              <button className="p-1 rounded-md border border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-600 dark:text-slate-300 transition-colors">
                <ChevronLeft className="w-4 h-4" />
              </button>
              <button className="p-1 rounded-md border border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-600 dark:text-slate-300 transition-colors">
                <ChevronRight className="w-4 h-4" />
              </button>
            </div>
          </div>

          <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4 shadow-2xs space-y-3 transition-colors">
            <div className="flex items-center gap-2">
              <span className="font-bold text-slate-900 dark:text-white text-xs">Chưa chốt ngày cụ thể</span>
              <span className="text-xs text-slate-500 dark:text-slate-400">5 hẹn · không xếp được vào lưới</span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
              {unconfirmedAppointments.map((item) => (
                <div
                  key={item.id}
                  className="bg-white dark:bg-slate-800/80 rounded-lg border border-slate-200 dark:border-slate-700 p-3 flex flex-col justify-between space-y-3 shadow-2xs transition-colors"
                >
                  <div>
                    <div className="flex items-center justify-between text-xs">
                      <span className="font-bold text-slate-900 dark:text-white truncate">{item.customer}</span>
                      <span className="text-[11px] text-slate-400 dark:text-slate-500 shrink-0 ml-1">{item.timeLabel}</span>
                    </div>
                    <p className="text-xs text-slate-600 dark:text-slate-300 mt-1 leading-snug">{item.service}</p>

                    <div className="flex flex-wrap gap-1 mt-2">
                      {item.badges.map((badge, bIdx) => (
                        <span
                          key={bIdx}
                          className={`px-2 py-0.5 rounded-full text-[10px] font-medium border ${
                            badge.type === 'amber'
                              ? 'bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-400 border-amber-200 dark:border-amber-800'
                              : 'bg-slate-100 dark:bg-slate-700/60 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-600'
                          }`}
                        >
                          • {badge.text}
                        </span>
                      ))}
                    </div>

                    <div className="mt-3 pt-2 border-t border-dashed border-slate-100 dark:border-slate-700/60 text-[11px] space-y-0.5 text-slate-500 dark:text-slate-400">
                      {item.estimatedValue && <div>{item.estimatedValue}</div>}
                      <div>
                        Chạm gần nhất: <span className="text-slate-700 dark:text-slate-300">{item.lastTouch}</span> · kế tiếp:{' '}
                        <span
                          className={
                            item.nextTouchOverdue
                              ? 'text-rose-600 dark:text-rose-400 font-bold'
                              : 'text-slate-700 dark:text-slate-300'
                          }
                        >
                          {item.nextTouch}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center gap-1.5 flex-wrap pt-1">
                    <button className="px-2.5 py-1 bg-teal-800 hover:bg-teal-900 dark:bg-teal-700 dark:hover:bg-teal-600 text-white font-medium rounded text-[11px] transition-colors shadow-2xs whitespace-nowrap">
                      Gọi chốt ngày
                    </button>
                    {item.phoneBtn && (
                      <button className="px-2 py-1 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-medium rounded border border-slate-200 dark:border-slate-700 text-[11px] transition-colors whitespace-nowrap">
                        Xin số điện thoại
                      </button>
                    )}
                    <button
                      onClick={() =>
                        setSelectedCustomer({
                          name: item.customer,
                          service: item.service,
                          status: item.badges[0]?.text || 'Chưa chốt ngày',
                          appointmentTime: item.timeLabel,
                          estimatedValue: item.estimatedValue,
                          nextTouch: item.nextTouch,
                          telesale: 'Ninh Giang',
                        })
                      }
                      className="px-2 py-1 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-medium rounded border border-slate-200 dark:border-slate-700 text-[11px] transition-colors whitespace-nowrap cursor-pointer"
                    >
                      Chi tiết
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 overflow-hidden shadow-2xs transition-colors">
            <div className="overflow-x-auto">
              <div className="min-w-[750px]">
                <div className="grid grid-cols-7 border-b border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/50 text-center text-xs font-semibold text-slate-500 dark:text-slate-400 py-2">
                  <div>T2</div>
                  <div>T3</div>
                  <div>T4</div>
                  <div>T5</div>
                  <div>T6</div>
                  <div>T7</div>
                  <div>CN</div>
                </div>

                <div className="grid grid-cols-7 divide-x divide-y divide-slate-100 dark:divide-slate-700/60 border-b border-slate-200 dark:border-slate-700">
                  {monthGridDays.map((cell, idx) => (
                    <div key={idx} className="min-h-[90px] p-2 flex flex-col justify-start">
                      {cell.dayNumber !== null && (
                        <>
                          <span className="text-xs font-medium text-slate-500 dark:text-slate-400">{cell.dayNumber}</span>
                          {cell.events.map((evt, eIdx) => (
                            <div
                              key={eIdx}
                              onClick={() =>
                                setSelectedCustomer({
                                  name: evt.customer,
                                  service: 'Thăm khám tư vấn',
                                  status: 'Đã chốt ngày giờ',
                                  appointmentTime: `${cell.dayNumber}/09 · ${evt.time}`,
                                  telesale: 'Quang',
                                })
                              }
                              className="mt-1.5 bg-slate-100/90 dark:bg-slate-700/60 hover:bg-slate-200 dark:hover:bg-slate-700 border-l-2 border-emerald-600 dark:border-emerald-500 rounded px-2 py-1 text-xs flex items-center gap-1.5 cursor-pointer transition-colors"
                            >
                              <span className="font-bold text-emerald-700 dark:text-emerald-400 text-[11px] shrink-0">
                                {evt.time}
                              </span>
                              <span className="font-semibold text-slate-800 dark:text-slate-200 text-xs truncate">
                                {evt.customer}
                              </span>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : activeTab === 'Tuần' ? (
        /* GIAO DIỆN TUẦN */
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-2xs overflow-hidden transition-colors">
          <div className="p-3.5 bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 flex flex-col sm:flex-row sm:items-center justify-between gap-2">
            <div>
              <div className="flex items-center gap-2">
                <span className="font-bold text-slate-900 dark:text-white text-sm">Tuần 24/8 – 30/8</span>
                <span className="text-slate-500 dark:text-slate-400 font-medium text-xs">
                  · hôm nay <strong className="text-slate-800 dark:text-slate-200">T6 28</strong>
                </span>
              </div>
              <p className="text-[11px] text-slate-400 dark:text-slate-500 mt-0.5">
                Chấm mờ: đã chạm · vàng: cần chạm · đỏ: quá hạn
              </p>
            </div>
            <span className="self-start sm:self-auto bg-slate-100 dark:bg-slate-700/50 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-600 px-2.5 py-1 rounded-full text-[11px] font-medium flex items-center gap-1">
              <span className="w-1.5 h-1.5 rounded-full bg-slate-400 inline-block"></span>
              Trực: ngày chạm lại, không phải ngày hẹn
            </span>
          </div>

          <div className="grid grid-cols-7 divide-x divide-slate-100 dark:divide-slate-700/60 border-b border-slate-200 dark:border-slate-700 min-h-[220px] overflow-x-auto">
            {weekDays.map((col, idx) => (
              <div key={idx} className="p-2 min-w-[110px] flex flex-col items-stretch">
                <div className="text-center text-xs font-semibold text-slate-500 dark:text-slate-400 pb-2.5 flex items-center justify-center gap-1">
                  <span>{col.dayLabel}</span>
                  {col.isToday && <span className="w-1.5 h-1.5 rounded-full bg-blue-500 inline-block"></span>}
                </div>

                <div className="space-y-1.5 flex-1">
                  {col.tasks.length > 0 ? (
                    col.tasks.map((task) => (
                      <div
                        key={task.id}
                        onClick={() =>
                          setSelectedCustomer({
                            name: task.customer,
                            service: task.service || 'Cấy tóc tự thân · 2.500 – 3.000 nang',
                            status: task.status,
                            appointmentTime: '02/10 · 10:00',
                            telesale: 'Quang',
                          })
                        }
                        className="bg-slate-100/80 dark:bg-slate-700/50 hover:bg-slate-200/80 dark:hover:bg-slate-700 px-2 py-1.5 rounded text-[11px] leading-tight flex items-center gap-1 text-slate-700 dark:text-slate-200 cursor-pointer transition-colors"
                      >
                        <span className="text-slate-400 dark:text-slate-400 font-normal shrink-0">
                          {task.status}
                        </span>
                        <span className="font-semibold truncate">{task.customer}</span>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-slate-300 dark:text-slate-600 text-xs pt-4">—</div>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="p-3 bg-white dark:bg-slate-800 text-[11px] text-slate-500 dark:text-slate-400">
            7 việc chạm rơi vào các tuần sau (mốc tháng 9) — xem ở chế độ Tháng.
          </div>
        </div>
      ) : (
        /* GIAO DIỆN NGÀY */
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-2xs overflow-hidden transition-colors">
          <div className="p-3.5 bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 flex flex-col sm:flex-row sm:items-center justify-between gap-2">
            <div>
              <div className="flex items-center gap-2">
                <span className="font-bold text-slate-900 dark:text-white text-sm">Thứ 6, 28/8/2026</span>
                <span className="text-blue-600 dark:text-blue-400 font-bold text-xs">• hôm nay</span>
              </div>
              <p className="text-[11px] text-slate-400 dark:text-slate-500 mt-0.5">
                3 việc chạm trong hôm nay và cận hạn
              </p>
            </div>
            <span className="self-start sm:self-auto bg-slate-100 dark:bg-slate-700/50 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-600 px-2.5 py-1 rounded-full text-[11px] font-medium flex items-center gap-1">
              <span className="w-1.5 h-1.5 rounded-full bg-slate-400 inline-block"></span>
              Trực: ngày chạm lại, không phải ngày hẹn
            </span>
          </div>

          <div className="divide-y divide-slate-100 dark:divide-slate-700/50">
            {timeSlots.map((slot) => (
              <div key={slot.time} className="flex items-stretch min-h-[50px]">
                <div className="w-16 sm:w-24 p-2 sm:p-3 bg-slate-50/50 dark:bg-slate-800/50 border-r border-slate-100 dark:border-slate-700/50 flex flex-col justify-start items-start text-slate-500 dark:text-slate-400 font-mono text-xs shrink-0">
                  <span className="font-bold text-slate-600 dark:text-slate-300">{slot.time}</span>
                  {slot.count > 0 && (
                    <span className="text-[10px] text-slate-400 dark:text-slate-500 mt-0.5">{slot.count} việc</span>
                  )}
                </div>

                <div className="flex-1 p-2 sm:p-3 flex flex-col justify-center overflow-x-auto">
                  {slot.tasks.length > 0 ? (
                    <div className="space-y-2">
                      {slot.tasks.map((task) => (
                        <div
                          key={task.id}
                          className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 sm:gap-4"
                        >
                          <div className="flex items-center gap-2 flex-wrap">
                            <span className="w-1 h-3.5 bg-cyan-600 dark:bg-cyan-500 rounded-full inline-block shrink-0"></span>
                            <span
                              onClick={() =>
                                setSelectedCustomer({
                                  name: task.customer,
                                  service: task.service,
                                  status: task.status,
                                  appointmentTime: `28/08 · ${slot.time}`,
                                  telesale: 'Ninh Giang',
                                })
                              }
                              className="font-bold text-slate-900 dark:text-slate-100 text-xs hover:underline cursor-pointer"
                            >
                              {task.customer}
                            </span>
                            <span className="text-slate-300 dark:text-slate-600 hidden sm:inline">·</span>
                            <span className="text-xs text-slate-600 dark:text-slate-300 font-medium">
                              {task.service}
                            </span>
                          </div>

                          <div className="flex items-center gap-2 self-start sm:self-auto">
                            <span className="bg-slate-100 dark:bg-slate-700/80 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-600 rounded-full px-2.5 py-0.5 text-[11px] font-medium flex items-center gap-1">
                              <span className="w-1.5 h-1.5 rounded-full bg-amber-400 inline-block"></span>
                              {task.status}
                            </span>
                            <button className="px-3 py-1 bg-white dark:bg-slate-700 hover:bg-slate-50 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 font-medium rounded-md border border-slate-200 dark:border-slate-600 text-xs shadow-2xs transition-colors">
                              Gọi chốt ngày
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-slate-400 dark:text-slate-500 text-xs font-normal text-center w-full">
                      Không có việc
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* 7. POPUP / DRAWER "TẠO HẸN TƯƠNG LAI" */}
      <Drawer
        title={<span className="font-bold text-base text-slate-900 dark:text-white">Tạo hẹn tương lai</span>}
        placement="right"
        onClose={() => setIsDrawerOpen(false)}
        open={isDrawerOpen}
        width={380}
        className="dark:[&_.ant-drawer-content]:!bg-slate-800 dark:[&_.ant-drawer-header]:!bg-slate-800 dark:[&_.ant-drawer-header]:!border-slate-700 dark:[&_.ant-drawer-close]:!text-slate-400 dark:[&_.ant-drawer-title]:!text-white"
      >
        <form onSubmit={handleCreateAppointment} className="space-y-4 text-xs">
          <div className="space-y-1.5">
            <label className="block font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider text-[11px]">
              TÊN KHÁCH
            </label>
            <input
              type="text"
              placeholder="Nguyễn Văn A"
              value={formData.customerName}
              onChange={(e) => setFormData({ ...formData, customerName: e.target.value })}
              className="w-full px-3 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-md text-xs focus:outline-none focus:border-blue-500 dark:focus:border-blue-400 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500"
            />
          </div>

          <div className="space-y-1.5">
            <label className="block font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider text-[11px]">
              SỐ ĐIỆN THOẠI
            </label>
            <input
              type="text"
              placeholder="09xx xxx xxx"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              className="w-full px-3 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-md text-xs focus:outline-none focus:border-blue-500 dark:focus:border-blue-400 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500"
            />
          </div>

          <div className="space-y-1.5">
            <label className="block font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider text-[11px]">
              DỊCH VỤ QUAN TÂM
            </label>
            <input
              type="text"
              placeholder="K-Lift Signature"
              value={formData.interestedService}
              onChange={(e) => setFormData({ ...formData, interestedService: e.target.value })}
              className="w-full px-3 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-md text-xs focus:outline-none focus:border-blue-500 dark:focus:border-blue-400 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500"
            />
          </div>

          <div className="space-y-1.5">
            <label className="block font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider text-[11px]">
              NHÓM DỊCH VỤ
            </label>
            <Select
              value={formData.serviceGroup}
              onChange={(val) => setFormData({ ...formData, serviceGroup: val })}
              options={[
                { value: 'Clinic', label: 'Clinic' },
                { value: 'Newhair', label: 'Newhair' },
                { value: 'PTTM', label: 'PTTM' },
              ]}
              popupClassName={customSelectPopupClass}
              className="w-full font-medium text-xs dark:[&_.ant-select-selector]:!bg-slate-900 dark:[&_.ant-select-selector]:!border-slate-700 dark:[&_.ant-select-selection-item]:!text-slate-200 dark:[&_.ant-select-arrow]:!text-slate-400"
            />
          </div>

          <div className="space-y-1.5">
            <label className="block font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider text-[11px]">
              LOẠI HẸN
            </label>
            <Select
              value={formData.appointmentType}
              onChange={(val) => setFormData({ ...formData, appointmentType: val })}
              options={[
                { value: 'Khách mới hẹn tư vấn', label: 'Khách mới hẹn tư vấn' },
                { value: 'Khách cũ hẹn tư vấn lại', label: 'Khách cũ hẹn tư vấn lại' },
                { value: 'Tái khám sau dịch vụ', label: 'Tái khám sau dịch vụ' },
              ]}
              popupClassName={customSelectPopupClass}
              className="w-full font-medium text-xs dark:[&_.ant-select-selector]:!bg-slate-900 dark:[&_.ant-select-selector]:!border-slate-700 dark:[&_.ant-select-selection-item]:!text-slate-200 dark:[&_.ant-select-arrow]:!text-slate-400"
            />
          </div>

          <div className="space-y-1.5">
            <label className="block font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider text-[11px]">
              TELESALE PHỤ TRÁCH
            </label>
            <Select
              value={formData.telesale}
              onChange={(val) => setFormData({ ...formData, telesale: val })}
              options={TELESALE_OPTIONS.filter((opt) => opt.value !== 'Tất cả')}
              popupClassName={customSelectPopupClass}
              className="w-full font-medium text-xs dark:[&_.ant-select-selector]:!bg-slate-900 dark:[&_.ant-select-selector]:!border-slate-700 dark:[&_.ant-select-selection-item]:!text-slate-200 dark:[&_.ant-select-arrow]:!text-slate-400"
            />
          </div>

          <div className="space-y-1.5">
            <label className="block font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider text-[11px]">
              NGÀY HẸN (THÁNG 9)
            </label>
            <input
              type="text"
              value={formData.day}
              onChange={(e) => setFormData({ ...formData, day: e.target.value })}
              className="w-full px-3 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-md text-xs focus:outline-none focus:border-blue-500 dark:focus:border-blue-400 text-slate-800 dark:text-slate-100 font-medium"
            />
          </div>

          <div className="space-y-1.5">
            <label className="block font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider text-[11px]">
              GIỜ
            </label>
            <input
              type="text"
              value={formData.time}
              onChange={(e) => setFormData({ ...formData, time: e.target.value })}
              className="w-full px-3 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-md text-xs focus:outline-none focus:border-blue-500 dark:focus:border-blue-400 text-slate-800 dark:text-slate-100 font-medium"
            />
          </div>

          <div className="pt-3">
            <button
              type="submit"
              className="w-full py-2.5 bg-teal-800 hover:bg-teal-900 dark:bg-teal-700 dark:hover:bg-teal-600 text-white font-bold rounded-md text-xs transition-colors shadow-2xs"
            >
              Tạo hẹn
            </button>
          </div>
        </form>
      </Drawer>

      {/* 8. DRAWER CHI TIẾT KHÁCH HÀNG (POPUP) */}
      <Drawer
        placement="right"
        onClose={() => setSelectedCustomer(null)}
        open={!!selectedCustomer}
        width={380}
        title={null}
        closeIcon={true}
        className="dark:[&_.ant-drawer-content]:!bg-slate-800 dark:[&_.ant-drawer-header]:!border-slate-700 dark:[&_.ant-drawer-close]:!text-slate-400"
      >
        {selectedCustomer && (
          <div className="space-y-6 text-xs text-slate-700 dark:text-slate-300 pt-2">
            <div>
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">HẸN TƯƠNG LAI</p>
              <h2 className="text-xl font-bold text-slate-900 dark:text-white my-1">{selectedCustomer.name}</h2>
              <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-800">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span> {selectedCustomer.status || 'Đã chốt ngày giờ'}
              </span>
            </div>

            <div className="bg-slate-50 dark:bg-slate-800/80 p-2.5 rounded-md border border-slate-100 dark:border-slate-700 space-y-1.5">
              <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">HÀNH TRÌNH KHÁCH</div>

              <div className="grid grid-cols-5 gap-1 pt-1">
                <div className="h-1 bg-emerald-600 rounded-full"></div>
                <div className="h-1 bg-slate-200 dark:bg-slate-700 rounded-full"></div>
                <div className="h-1 bg-slate-200 dark:bg-slate-700 rounded-full"></div>
                <div className="h-1 bg-slate-200 dark:bg-slate-700 rounded-full"></div>
                <div className="h-1 bg-slate-200 dark:bg-slate-700 rounded-full"></div>
              </div>

              <div className="grid grid-cols-5 text-[9px] pt-0.5 text-center">
                <span className="text-emerald-600 font-medium">Hẹn</span>
                <span className="text-slate-400 font-medium">Tiếp đón</span>
                <span className="text-slate-400 font-medium">Tư vấn</span>
                <span className="text-slate-400">Xếp ca</span>
                <span className="text-slate-400">Thực hiện</span>
              </div>

              <p className="text-[11px] text-slate-500 dark:text-slate-400 mt-2">
                <strong className="text-slate-700 dark:text-slate-200">Hẹn:</strong> hẹn {selectedCustomer.appointmentTime || '02/10 10:00'}
              </p>
            </div>

            <div>
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-3">THÔNG TIN HẸN</p>
              <div className="space-y-2.5">
                <div className="flex justify-between">
                  <span className="text-slate-500 dark:text-slate-400">Thời điểm</span>
                  <span className="font-semibold text-slate-900 dark:text-slate-100">
                    {selectedCustomer.appointmentTime || '02/10 · 10:00'}
                  </span>
                </div>
                <div className="flex justify-between items-start">
                  <span className="text-slate-500 dark:text-slate-400">Dịch vụ</span>
                  <span className="font-semibold text-slate-900 dark:text-slate-100 text-right max-w-[200px]">
                    {selectedCustomer.service || 'Cấy tóc tự thân · 2.500 – 3.000 nang'}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-500 dark:text-slate-400">Loại hẹn</span>
                  <span className="font-semibold text-slate-900 dark:text-slate-100">Khách mới hẹn tư vấn</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-500 dark:text-slate-400">Telesale</span>
                  <span className="font-semibold text-slate-900 dark:text-slate-100">
                    {selectedCustomer.telesale || 'Ninh Giang'}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-500 dark:text-slate-400">Điện thoại</span>
                  <span className="font-semibold text-slate-900 dark:text-slate-100">
                    {selectedCustomer.phone || '09••• (hồ sơ)'}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-500 dark:text-slate-400">Giá trị dự kiến</span>
                  <span className="font-semibold text-slate-900 dark:text-slate-100">
                    {selectedCustomer.estimatedValue || '85.000.000'}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-500 dark:text-slate-400">Chạm kế tiếp</span>
                  <span className="font-semibold text-slate-900 dark:text-slate-100">
                    {selectedCustomer.nextTouch || '15/9'}
                  </span>
                </div>
              </div>
            </div>

            <div>
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">LỊCH SỬ CHẠM</p>
              <p className="text-slate-600 dark:text-slate-300">24/8 · chốt ngày sau 2 lần tư vấn</p>
            </div>

            <div className="flex gap-2 pt-2">
              <button className="px-3 py-1.5 rounded-md border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 font-medium text-slate-700 dark:text-slate-200 text-xs transition-colors">
                Dời hẹn
              </button>
              <button className="px-3 py-1.5 rounded-md border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 font-medium text-slate-700 dark:text-slate-200 text-xs transition-colors">
                Huỷ hẹn
              </button>
            </div>
          </div>
        )}
      </Drawer>
    </div>
  );
}